import { useEffect, useMemo, useState } from 'react';

import { useCurrentPromoterQuery } from '@queries/PromoterQueries';

import { AppStorageKey } from '@utilities/appStorage';

const CURRENT_PROMOTER_LOCAL_STORAGE_KEY = 'gaggl::currentPromoterId';

export const useCurrentPromoter = () => {
  const [currentPromoterId, setCurrentPromoterId] = useState<string | undefined>(
    localStorage.getItem(CURRENT_PROMOTER_LOCAL_STORAGE_KEY) ?? undefined,
  );
  const { promoterIsReady, promoter: defaultPromoter, promoters = [] } = useCurrentPromoterQuery();

  const promoter = useMemo(() => {
    return currentPromoterId
      ? (promoters.find((promoter) => promoter._id === currentPromoterId) ?? defaultPromoter)
      : defaultPromoter;
  }, [defaultPromoter, promoters, currentPromoterId]);

  const changeCurrentPromoter = (promoterId: string) => {
    setCurrentPromoterId(promoterId);
    localStorage.setItem(CURRENT_PROMOTER_LOCAL_STORAGE_KEY, promoterId);
  };

  return {
    isPromoterReady: promoterIsReady,
    promoter,
    promoters,
    changeCurrentPromoter,
  };
};
